module.exports = __webpack_public_path__ + "img/submit-demo.0846d3f3.svg";